function Tab1() {
  var tab1 = document.getElementById("tab1");
  var tab2 = document.getElementById("tab2");
  var tab3 = document.getElementById("tab3");
  var Tab1 = document.getElementById("Tab1");
  var Tab2 = document.getElementById("Tab2");
  var Tab3 = document.getElementById("Tab3");
    tab1.style.display = "block";
    tab2.style.display = "none";
    tab3.style.display = "none";
    Tab1.style.backgroundColor = "#ffbf3c";
    Tab2.style.backgroundColor = "#ffd37a";
    Tab3.style.backgroundColor = "#ffd37a";
}
function Tab2() {
  var tab1 = document.getElementById("tab1");
  var tab2 = document.getElementById("tab2");
  var tab3 = document.getElementById("tab3");
  var Tab1 = document.getElementById("Tab1");
  var Tab2 = document.getElementById("Tab2");
  var Tab3 = document.getElementById("Tab3");
    tab1.style.display = "none";
    tab2.style.display = "block";
    tab3.style.display = "none";
    Tab1.style.backgroundColor = "#ffd37a";
    Tab2.style.backgroundColor = "#ffbf3c";
    Tab3.style.backgroundColor = "#ffd37a";
}
function Tab3() {
  var tab1 = document.getElementById("tab1");
  var tab2 = document.getElementById("tab2");
  var tab3 = document.getElementById("tab3");
  var Tab1 = document.getElementById("Tab1");
  var Tab2 = document.getElementById("Tab2");
  var Tab3 = document.getElementById("Tab3");
    tab1.style.display = "none";
    tab2.style.display = "none";
    tab3.style.display = "block";
    Tab1.style.backgroundColor = "#ffd37a";
    Tab2.style.backgroundColor = "#ffd37a";
    Tab3.style.backgroundColor = "#ffbf3c";
}